<template>
  <div class="page-selector" v-if="product">
    <!-- <h1 class="block-title">เลือกประเภทการบริจาค</h1> -->
    <div class="form__wrapper">
      <div class="form__section">
        <div class="alert alert--error" v-show="$v.$errors['type'].empty">กรุณาเลือกประเภทการบริจาค</div>

        <div class="form__item form__item--inline">
          <label class="form__label form__label--title">
            <input class="form__input" type="radio" name="type" value="4" v-model="type" />
            <span class="icon _sl-tcfe">&nbsp;</span>บริจาคทันที<br />
            <!-- <span class="remark">เงินบริจาคของคุณจะเข้าสู่โครงการผ้าป่าการศึกษา</span> -->
          </label>
        </div>
      </div>
      <div class="tab-remark">
        <div class="label">หรือเลือกประเภทบริจาค</div>
      </div>
      <div class="form__section">
        <div class="form__item form__item--inline">
          <label class="form__label form__label--title">
            <input class="form__input" type="radio" name="type" value="3" v-model="type" />
            <span class="icon _sl-school">&nbsp;</span>เลือกโรงเรียนที่ต้องการบริจาค
          </label>
          <div class="form__sub-section" v-if="type == 3 && !selectedPage">
            <div class="form__select">
              <select v-model="province2" @change="selectProvince">
                <option value="">- จังหวัด -</option>
                <option :value="province.id" v-for="province in provinces">{{ province.name }}</option>
              </select>
            </div>
            <div class="alert alert--error" v-show="$v.$errors['province2'].empty">กรุณาเลือกจังหวัด</div>
            <div class="form__select">
              <select v-model="school" @change="selectSchool">
                <option value="">- โรงเรียน -</option>
                <option :value="school.id" v-for="school in schools">{{ school.name }}</option>
              </select>
            </div>
            <div class="alert alert--error" v-show="$v.$errors['school'].empty">กรุณาเลือกโรงเรียน</div>
          </div>
          <div class="form__sub-section" v-if="type == 3 && selectedPage">
            <div class="result-selected shadow">
              <page-preview :page="selectedPage" @clear="clear" />
            </div>
          </div>
        </div>
      </div>
      <div class="form__section">
        <div class="form__item form__item--inline">
          <label class="form__label form__label--title">
            <input class="form__input" type="radio" name="type" value="2" v-model="type" />
            <span class="icon _sl-province">&nbsp;</span>เลือกจังหวัดที่ต้องการบริจาค
          </label>
          <div class="form__sub-section" v-if="type == 2 && !selectedPage">
            <div class="form__select">
              <select v-model="province" @change="selectProvince">
                <option value="">- จังหวัด -</option>
                <option :value="province.id" v-for="province in provinces">{{ province.name }}</option>
              </select>
            </div>
            <div class="alert alert--error" v-show="$v.$errors['province'].empty">กรุณาเลือกจังหวัด</div>
          </div>
          <div class="form__sub-section" v-if="type == 2 && selectedPage">
            <div class="result-selected shadow">
              <page-preview :page="selectedPage" @clear="clear" />
            </div>
          </div>
        </div>
      </div>
      <div class="form__section">
        <div class="form__item form__item--inline">
          <label class="form__label form__label--title">
            <input class="form__input" type="radio" name="type" value="1" v-model="type" />
            <span class="icon _sl-phapa">&nbsp;</span>เลือกกองผ้าป่าที่คุณต้องการบริจาค
          </label>
          <div class="form__sub-section" v-if="type == 1 && !selectedPage">
            <input class="form__text_lg txt-search" type="text" autocomplete="off" v-model="search" @keyup="searchKeyUp" @focus="searchKeyUp" @blur="searchUnfocus()" ref="searchInput" />
            <ul class="result-list" v-if="pageResults.length > 0">
              <li class="result-item" v-for="page in pageResults">
                <a href="#" @click.prevent="selectPage(page)">{{ page.title }}</a>
              </li>
            </ul>
            <div class="alert alert--error" v-show="$v.$errors['selectedPage'].empty">กรุณาเลือกกองผ้าป่า</div>
          </div>
          <div class="form__sub-section result-selected shadow" v-if="type == 1 && selectedPage">
            <page-preview :page="selectedPage" @clear="clearSelectPage" />
          </div>
        </div>
      </div> <!-- form__section -->
    </div> <!-- form__wrapper -->
  </div>
</template>

<script>
import PagePreview from './PagePreview.vue'

export default {
  name: 'PageSelector',

  components: {
    PagePreview
  },

  props: {
    product: {
      type: Object,
      default: null
    }
  },

  created () {
    this.getCategories()
    this.getOfficialPages()

    this.$v = this.$validator.init(this, {
      type: { checkEmpty: true },
      selectedPage: { checkEmpty: true, dependOn: { field: 'type', value: '1' } },
      province: { checkEmpty: true, dependOn: { field: 'type', value: '2' } },
      province2: { checkEmpty: true, dependOn: { field: 'type', value: '3' } },
      school: { checkEmpty: true, dependOn: { field: 'type', value: '3' } }
    })
  },

  data () {
    return {
      type: 0,
      selectedPage: null,
      search: '',
      province: '',
      province2: '',
      school: '',
      pageResults: [],
      categories: [],
      provinces: [],
      schools: [],
      pages: [],
      searchNullable: true,
      searchResultIpp: 1000,
      showLoadingPage: false,
      $v: null
    }
  },

  methods: {
    getOfficialPages () {
      this.$utils.getOfficialPages(this.product.id)
        .then(pages => {
          this.pages = pages
          this.type = 4
          this.$nextTick(() => {
            this.selectCommonPage()
          })
          this.$emit('pages', pages)
        })
    },

    getCategories () {
      this.$http.get('categories')
        .then(resp => {
          this.categories = resp.body.categories
          this.provinces = this.categories.filter(category => !category.parent_id)
          return resp
        })
        .catch(err => {
          this.$modal.show({
            title: 'เกิดข้อผิดพลาด',
            text: `ไม่สามารถดึงข้อมูลได้. ${err.message}.`,
            okButtonText: 'ลองใหม่อีกครั้ง',
            ok: () => {
              window.location.reload()
            }
          })
        })
    },

    selectPage (page) {
      this.selectedPage = page
      this.$emit('input', this.selectedPage)
      this.$forceUpdate()
    },

    getSchools (province) {
      this.schools = this.categories.filter(category => category.parent_id === province)
    },

    selectCommonPage () {
      this.selectPage(this.pages.find(page => !page.categories))
    },

    selectProvince () {
      if (this.type === '2') {
        const page = this.pages.find(page => page.categories && page.categories.indexOf(this.province) >= 0 && page.data.official_province)
        this.selectPage(page)
      } else if (this.type === '3') {
        this.getSchools(this.province2)
      }
    },

    selectSchool () {
      if (this.type === '3' && this.school && this.province2) {
        const page = this.pages.find(page => page.categories && page.categories.indexOf(this.school) >= 0 && page.data.official_school)
        this.selectPage(page)
      }
    },

    searchKeyUp () {
      this.pageResults = []

      if (this.keyTimer) {
        clearTimeout(this.keyTimer)
        this.keyTimer = null
      }
      this.keyTimer = setTimeout(() => {
        this.searchPages()
      }, 300)
    },

    searchPages () {
      const searchInput = this.search.trim()
      if (searchInput || this.searchNullable) {
        this.showLoadingPage = true

        const params = {
          keyword: searchInput,
          ipp: this.searchResultIpp
        }
        this.$http.get('pages', {
          params,
          before (request) {
            // abort previous request, if exists
            if (this.previousRequest) {
              this.previousRequest.abort()
            }
            // set previous request on Vue instance
            this.previousRequest = request
          }
        })
        .then(resp => {
          this.showLoadingPage = false
          this.pageResults = []
          if (resp.body.pages) {
            resp.body.pages.forEach(page => {
              try {
                page.data = JSON.parse(page.data)
              } catch (err) {
                console.log(err)
                page.data = {}
              }
              this.pageResults.push(page)
            })
          }
        })
      }
    },

    searchUnfocus () {
      setTimeout(() => {
        this.pageResults = []
      }, 200)
    },

    validate () {
      if (!this.$v.validate()) {
        this.$forceUpdate()
        this.$utils.scrollToFirstErrors()
        return false
      }
      return true
    },

    clear () {
      this.selectPage(null)
      this.school = ''
      this.province = ''
      this.province2 = ''
      this.search = ''
      this.pageResults = []
      this.schools = []
    },

    clearSelectPage () {
      const previousSearch = this.search.toString()
      this.clear()
      this.search = previousSearch
      this.$nextTick(() => {
        this.$refs.searchInput.focus()
      })
    }
  },

  watch: {
    type: function (newValue, oldValue) {
      this.clear()
      if (newValue === '4') {
        this.selectCommonPage()
      } else if (newValue === '1') {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-selector {
  background: #fff;
  > .block-title {
    color: #fff;
    background: #222324;
    margin: 15px 0 15px -15px;
    padding: 15px 70px 15px 25px;
    display: inline-block;
  }
}
  .form__section {
    padding: 30px 15px;
    border-bottom: 1px solid #dfdfdf;
    &:first-child {
      border-bottom: 3px solid #dfdfdf;
      padding: 30px 15px 35px;
    }
  }
  .form__label {
    font-size: 21px !important;
    font-weight: 400 !important;
    display: inline-block;
    line-height: 1.5em;
    > .icon {
      display: inline-block;
      padding-left: 30px;
      background: url("../assets/img/ic-tcfe@2x.png") no-repeat left center;
      background-size: 20px !important;
      &._sl-phapa { background: url("../assets/img/icon/ic-page-sm@2x.png") no-repeat left center; background-size: 25px !important; }
      &._sl-province {background: url("../assets/img/ic-province@2x.png") no-repeat left center;}
      &._sl-school {background: url("../assets/img/ic-school@2x.png") no-repeat left center;}
      &._sl-tcfe {background: url("../assets/img/ic-tcfe@2x.png") no-repeat left center;}
    }
    .remark {
      font-weight: 300;
      font-size: 0.8em;
      line-height: 1.3em;
      display: inline-block;
      margin-left: 60px;
    }
  }
  .form__sub-section {
    margin: 15px 15px 15px 60px;
  }
  // result
  .result-list {
    width: 80%;
    border: 1px solid rgb(151, 151, 151);
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 300px;
    overflow-y: scroll;
    > .result-item {
      border-bottom: 1px solid rgb(151, 151, 151);;
      margin: 0;
      a {
        display: block;
        padding: 2% 3%;
      }
      &:last-child { border-bottom: 0; }
    }
  }
  .result-selected {
    width: 80%;
    border: 1px solid rgb(151, 151, 151);
    padding: 2% 3%
  }
.tab-remark {
  text-align: center;
  margin-top: -15px;
  > .label {
    background: #989898;
    border-radius: 20px;
    display: inline-block;
    padding: 5px 30px;
    font-weight: 300;
    color: #fff;
  }
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 767px) {
  .form__wrapper { margin-bottom: 20px; }
  .page-selector {
    .form__sub-section {
      margin: 15px 15px 15px 25px;
    }
    .form__label {
      font-size: 20px !important;
      > .icon {
        padding-left: 20px;
        background-size: 15px !important;
        &._sl-phapa { background-size: 16px !important; }

      }
      .remark {
        margin-left: 0;

      }
    }
  }
}

/* On screens that are 600px or less */
@media screen and (max-width: 425px) {
  .page-selector {
    .form__section {
      padding: 15px 10px;
    }
    .form__sub-section {
      margin: 15px 15px 15px 25px;
    }
    .form__label {
      font-size: 17px !important;
      > .icon {
        padding-left: 16px;
        background-size: 13px !important;
      }
      .remark {
        margin-left: 0;

      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// PageSelector.vue?256aa4ba